import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ProductsSvc} from '../../dashboard/services';
import {UserSvc} from './user.service';
import {forkJoin, from, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable()
export class DashboardResolverService implements Resolve<any> {

  constructor(public productSvc: ProductsSvc, public userSvc: UserSvc) { }

  public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    if (state.url !== '/dashboard/list') {
      return of(false);
    }

    return forkJoin({
      user: from(this.userSvc.getUser()),
      totalVCSProducts: this.productSvc.getCountVCSProducts()
    }).pipe(
      map(({user, totalVCSProducts}) => {
        return !user.hasSeenVCSProduct && user.applicationDisclaimerAccepted && totalVCSProducts > 0;
      })
    );
  }
}
